import { render } from "./BaseImmotion.vue?vue&type=template&id=8ac00534&scoped=true"
import script from "./BaseImmotion.vue?vue&type=script&lang=js"
export * from "./BaseImmotion.vue?vue&type=script&lang=js"

import "./BaseImmotion.vue?vue&type=style&index=0&id=8ac00534&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac00534"]])

export default __exports__